import { module } from 'modujs';
import modularLoad from 'modularload';
import shared from '../shared';
import { $body } from '../utils/dom';
import gsap from "gsap";
import lottie from "lottie-web";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const load = new modularLoad({
            enterDelay: 1500,
            transitions: {
                customTransition: {}
            }
        });

        this.DOM = {
            loading: document.querySelector('.o-loading'),
            logo: document.querySelector('.o-loading_logo'),
            logoLetters: document.querySelectorAll('.o-loading_logo_letter'),
            pct: document.querySelector('.o-loading_pct'),
            pctValue: document.querySelector('.o-loading_pct_value'),
            lottie: document.querySelector('.o-loading_lottie'),
            fake: document.querySelector('.o-loading_fake'),
            bgMain: document.querySelector('.o-loading_background.-main'),
            bgSecond: document.querySelector('.o-loading_background.-second')
        };

        this.lottieAnim = null;

        if (this.DOM.lottie) {
            this.lottieAnim = lottie.loadAnimation({
                container: this.DOM.lottie,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: this.DOM.lottie.getAttribute('data-lottie-src'),
            });
            this.DOM.lottie.setAttribute('data-lottie-id', this.lottieAnim.animationID);
        }

        window.addEventListener('loading-hide', () => { this.hide(0.5); });
        window.addEventListener('loading-pct', () => { this.animatePct(); });

        load.on('loading', (oldContainer, newContainer) => {
            this.show();
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            shared();

            // -------------------------------------
            // Force WPCF7 forms to re-init
            // -------------------------------------
            document.querySelectorAll(".wpcf7 > form").forEach((
                function(e){
                    return wpcf7.init(e)
                }
            ));

            // Update body class
            this.setNewBodyClass();

            this.hide();

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            // setTimeout(() => {
            //     this.call('resetStyle', 'Navbar');
            // }, 100);
        });
        
    }

    show () {
        this.call('stop', 'Scroll');
        this.DOM.loading.classList.remove('-hidden');

        let tl = gsap.timeline();

        tl.fromTo(this.DOM.bgSecond,
            { yPercent: 100 },
            { yPercent: 0, duration: 1, ease: 'expo.inOut' },
            0
        );
        tl.fromTo(this.DOM.bgMain,
            { yPercent: 100 },
            { yPercent: -0, duration: 1, ease: 'expo.inOut' },
            0.2
        );
        tl.fromTo(this.DOM.logoLetters,
            { yPercent: 120 },
            { yPercent: 0, duration: 0.4, ease: 'expo.out', stagger: 0.03 },
            0.7
        );

    }

    hide (delay = 0) {
        let tl = gsap.timeline({ delay: delay, onComplete: () => {
            this.DOM.loading.classList.add('-hidden');
            this.call('start', 'Scroll');
        } });

        tl.fromTo(this.DOM.logoLetters,
            { yPercent: 0 },
            { yPercent: -120, duration: 0.4, ease: 'expo.out', stagger: 0.03 },
            0.2
        );
        tl.to(this.DOM.pct, { opacity: 0, duration: 0.2, ease: 'none' }, 0);
        tl.to(this.DOM.lottie, { opacity: 0, duration: 0.2, ease: 'none' }, 0);
        tl.fromTo(this.DOM.bgMain,
            { yPercent: 0 },
            { yPercent: -100, duration: 1, ease: 'expo.inOut' },
            0
        );
        tl.fromTo(this.DOM.bgSecond,
            { yPercent: 0 },
            { yPercent: -100, duration: 1, ease: 'expo.inOut' },
            0.2
        );

        setTimeout(() => {
            window.dispatchEvent(new Event("p-loaded"));
        }, 400);
    }

    animatePct () {
        this.lottieAnim.play();
        
        gsap.set(this.DOM.logo, { opacity: 1 });
        gsap.fromTo(this.DOM.logoLetters,
            { yPercent: 120, opacity: 0 },
            { yPercent: 0, opacity: 1, duration: 0.6, ease: 'expo.out', delay: 0.5, stagger: 0.03 }
        );
        gsap.fromTo(this.DOM.pct,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.4, delay: 0.5, ease: 'expo.out' }
        );
        gsap.to(this.DOM.pctValue, {
            textContent: 100,
            duration: 4,
            delay: 0.5,
            ease: 'expo.inOut',
            snap: { textContent: 1 },
            stagger: 1,
            onComplete: () => {
                gsap.to(this.DOM.pct, { opacity: 0, y: -20, duration: 0.2, ease: 'power2.out' });
                this.hide();
            }
        });
    }

    setNewBodyClass () {
        if (this.el.querySelector('[data-bodyclass]')) {
            let bodyClass = this.el.querySelector('[data-bodyclass]').getAttribute('data-bodyclass');
            $body.className = bodyClass;
        }
    }
}
